module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANBAMAAACAxflPAAAAAXNSR0IB2cksfwAAABhQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVjccKgAAAAh0Uk5TAFD/YM8wnNC4pmuVAAAAPUlEQVR4nGMQZIAAJQMgYRLAYKTMwMCsJADEBmA2kGAGyzErJSmDVRqBuXAaJg5VB9MnBDJHHUiDFIkyAAB4mgcsxmWYKgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/schedule-compose-close.png
// module id = 897
// module chunks = 0